import React from "react";
import useAuth, {
    AuthData,
    AuthLoadedTemplate,
    AuthenticatedTemplate,
    UnauthenticatedTemplate,
    handleLogin,
} from "../hooks/useAuth";
import {
    Tooltip,
    TooltipProvider,
    TooltipTrigger,
    TooltipContent,
} from "../ui/Tooltip";

const UserPersona: React.FC<{ isOpen: boolean }> = ({ isOpen }) => {
    const authData: AuthData = useAuth();
    
    const personaText = authData?.clientPrincipal?.userDetails
        ? authData?.clientPrincipal?.userDetails
        : "Guest";
    
    return (
        <AuthLoadedTemplate>
            <div className="flex gap-2 items-center px-[4px]">
                <TooltipProvider>
                    <Tooltip>
                        <TooltipTrigger className="rounded-full w-[24px] h-[24px] text-[9px] bg-accent1 flex text-gray-100 items-center justify-center font-bold cursor-default">
                            {personaText[0].toLocaleUpperCase()}
                        </TooltipTrigger>
                        <TooltipContent side={isOpen ? "top" : "right"}>
                            <div className="flex flex-col">
                                {personaText}
                                {!isOpen && (
                                    <>
                                        <UnauthenticatedTemplate>
                                            <a href="/.auth/login/aad" onClick={handleLogin}>
                                                <span className="text-xs text-black dark:text-white">
                                                    Sign In
                                                </span>
                                            </a>
                                        </UnauthenticatedTemplate>{" "}
                                        <AuthenticatedTemplate>
                                            <a href="/.auth/logout">
                                                <span className="text-xs text-black dark:text-white">
                                                    Sign Out
                                                </span>
                                            </a>
                                        </AuthenticatedTemplate>
                                    </>
                                )}
                            </div>
                        </TooltipContent>
                    </Tooltip>
                </TooltipProvider>

                {isOpen && (
                    <>
                        <UnauthenticatedTemplate>
                            <a href="/.auth/login/aad" onClick={handleLogin}>
                                <p className="text-sm text-gray-700 dark:text-gray-300 w-fit duration-300 hover:bg-gray-300 dark:hover:bg-gray-700 p-1 rounded-md px-2">
                                    Sign In
                                </p>
                            </a>
                        </UnauthenticatedTemplate>{" "}
                        <AuthenticatedTemplate>
                            <a href="/.auth/logout">
                                <p className="text-sm text-gray-700 dark:text-gray-300 w-fit duration-300 hover:bg-gray-300 dark:hover:bg-gray-700 p-1 rounded-md px-2">
                                    Sign Out
                                </p>
                            </a>
                        </AuthenticatedTemplate>
                    </>
                )}
            </div>
        </AuthLoadedTemplate>
    );
};

export default UserPersona;